
export function getOffset (el) {
  el = el.getBoundingClientRect()
  return {
    left: el.left + window.scrollX,
    top: el.top + window.scrollY
  }
}

export function windowSize () {
  var e = window;
  var a = 'inner';
  if (!('innerWidth' in window)) {
    a = 'client';
    e = document.documentElement || document.body;
  }
  return {width: e[a + 'Width'], height: e[a + 'Height']};
}

export function lazyloadSet (c) {
  c.querySelectorAll('.image').forEach((el) => {
    const im = el.querySelector('img');
    // set lazy load on all images matching figure.lazyload images
    if (im) {
      el.classList.add('loading', 'lazyload');
      const src = im.getAttribute('src');
      im.setAttribute('data-src', src);
      im.removeAttribute('src');
      if (im.hasAttribute('srcset')) {
        const srcset = im.getAttribute('srcset');
        im.setAttribute('data-srcset', srcset);
        im.removeAttribute('srcset');
      }
    }
  });
}
export function lazyloadUnset (c) {
  c.querySelectorAll('.image').forEach((el) => {
    const im = el.querySelector('img');
    // unset lazy load on all images matching figure.lazyload images
    if (im) {
      const src = im.getAttribute('data-src');
      im.setAttribute('src', src);
      im.removeAttribute('data-src');
      if (im.hasAttribute('data-srcset')) {
        const srcset = im.getAttribute('data-srcset');
        im.setAttribute('srcset', srcset);
        im.removeAttribute('data-srcset');
      }
      im.addEventListener('load', function () {
        el.classList.add('loaded');
      });
    }
  });
}

export function findClosest (el, sel) {
  if (typeof el.closest === 'function') {
    return el.closest(sel) || null;
  }
  while (el) {
    if (el.matches(sel)) {
      return el;
    }
    el = el.parentElement;
  }
  return null;
}

export function trackCurrentSection (container, t, l, d, currentSection, pt, pDirection, pDistance, wh, triggerPoint, callback) {
  let threshold = currentSection === '' ? 0 : 20;

  const currentDirection = pt > t ? 'up' : 'down';
  // increase thresholdTicker if same direction
  let distance = pDirection === currentDirection ? pDistance + 1 : 0;
  let currentSections = [];
  container.querySelectorAll('section').forEach((section) => {
    // first store all the current visible sections (top half of screen)
    const sectionOffsetTop = window.featureHeight + section.offsetTop;
    // if (t + (wh / 2) > sectionOffsetTop && t < sectionOffsetTop + section.offsetHeight) {
    if (t + (wh * triggerPoint) > sectionOffsetTop && t < sectionOffsetTop + section.offsetHeight) {
      currentSections.push(section);
    }
  });
  // set the current section depending on your scroll direction
  let selectedSection = currentSections[ pt < t ? currentSections.length - 1 : 0 ];
  if (distance >= threshold &&
      selectedSection &&
      selectedSection !== currentSection &&
      window.Modernizr.history) {
    // run requested callback function
    callback(selectedSection);
    // set the current article
    currentSection = selectedSection;
  }
  return { s: currentSection, t: t, direction: d, distance: distance };
}



// WEBPACK FOOTER //
// ./assets/j/util/miscellaneous.js